export default [
    {
        title: 'Article',
        customIcon: 'ArticleSVG',
        children: [
          {
            title: 'Article List',
            route: "custom-article-list",
            path: '/custom-article/list',
          },
          {
            title: 'Article Category',
            route: "custom-article-category",
            path: '/custom-article/category',
          }
        ]
    },
];